export default __webpack_public_path__ + "static/media/SN-Piktogramm.9e5f7dc6.svg";